import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import userAgent from '@/services/userAgent.service';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockPortrait',
  props: {
    bodyText: null,
    reversed: { type: Boolean },
    link: null,
    backgroundColor: { default: 'transparent' },
    textColor: null,
    buttonText: { default: undefined },
    buttonColor: { default: null },
    useFilledButton: { type: Boolean },
    isTextCentered: { type: Boolean },
    newsletterPopupCta: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { bodyText?: string, reversed?: boolean, link?: LinkViewObject, backgroundColor: string, textColor?: string, buttonText: string, buttonColor: string | null, useFilledButton?: boolean, isTextCentered?: boolean, newsletterPopupCta?: boolean }



function toggleNewsletterModal() {
    store.dispatch('navigation/toggleNewsletterModal');
}
const url = computed<string>(() => props.link ? props.link.url : null);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const linkIsExternal = computed<boolean>(() => props.link && props.link.isExternal);
const openLinkInNewWindow = computed<boolean>(() => props.link && props.link.openInNewWindow);

function newsletterPopupAction() : void {
    if (props.newsletterPopupCta) {
        toggleNewsletterModal();
    }
}

function initAnimations(): void {
    runAnimations.value = true;
}

const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);
const runAnimations = ref<boolean>(userAgent.isPrerender);

return { __sfc: true,props, toggleNewsletterModal, url, theme, linkIsExternal, openLinkInNewWindow, newsletterPopupAction, initAnimations, isInEditMode, runAnimations }
}

})